import { Link } from 'react-router-dom';
import { propFirms } from '@/mocks/propfirms';

export default function HomePropFirms() {
  const topFirms = propFirms.slice(0, 3);

  return (
    <section className="py-20 bg-[#f0f6ff]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-xs font-semibold px-4 py-2 rounded-full mb-4">
            <i className="ri-bar-chart-2-line"></i>
            Análise Imparcial 2026
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0d1f3c] mb-4">
            As Melhores Prop Firms de Futuros
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto">
            Analisámos as principais prop firms do mercado para si. Comparamos taxas, regras, profit split e reputação.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {topFirms.map((firm, index) => (
            <div
              key={firm.id}
              className="bg-white rounded-2xl border border-blue-100 p-6 hover:border-blue-300 transition-all cursor-pointer relative"
            >
              {index === 0 && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                  #1 Mais Recomendada
                </div>
              )}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-sm ${i < Math.floor(firm.rating) ? 'text-yellow-400' : 'text-slate-200'}`}
                    ></i>
                  ))}
                  <span className="text-sm text-slate-500 ml-1">{firm.rating}</span>
                </div>
                <span className="text-2xl font-extrabold text-blue-600">{firm.score}</span>
              </div>
              <h3 className="text-xl font-bold text-[#0d1f3c] mb-1">{firm.name}</h3>
              <p className="text-xs text-slate-400 mb-4">{firm.badge}</p>
              <div className="grid grid-cols-2 gap-3 mb-5">
                <div className="bg-blue-50 rounded-lg p-3 text-center">
                  <div className="text-xs text-slate-500 mb-1">Profit Split</div>
                  <div className="font-bold text-blue-700 text-sm">{firm.profitSplit}</div>
                </div>
                <div className="bg-blue-50 rounded-lg p-3 text-center">
                  <div className="text-xs text-slate-500 mb-1">Capital Máx.</div>
                  <div className="font-bold text-blue-700 text-sm">{firm.maxFunding}</div>
                </div>
              </div>
              <ul className="space-y-1.5 mb-5">
                {firm.pros.slice(0, 3).map((pro) => (
                  <li key={pro} className="flex items-start gap-2 text-sm text-slate-600">
                    <i className="ri-check-line text-green-500 mt-0.5 shrink-0"></i>
                    {pro}
                  </li>
                ))}
              </ul>
              <a
                href={firm.affiliateUrl}
                className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                Começar com {firm.name}
              </a>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/comparacao"
            className="inline-flex items-center gap-2 border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-bold px-8 py-3.5 rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-table-line"></i>
            Ver Comparação Completa de Todas as Prop Firms
          </Link>
        </div>
      </div>
    </section>
  );
}
